// Put static endpoint response behind url to enable caching

export default {
  // providers: ,
  // labels: ,
  // 'regulations/nhg': ,
  // 'overview/interest?nhg=0&mortgage=300000&houseValue=300000&mortgageType=6&frt=20': ,
  // 'overview/interest?nhg=0&mortgage=300000&houseValue=300000&mortgageType=6&frt=1': ,
  // 'overview/interest?nhg=0&mortgage=300000&houseValue=300000&mortgageType=6&frt=5': ,
  // 'overview/interest?nhg=0&mortgage=300000&houseValue=300000&mortgageType=6&frt=10': ,
  // 'overview/interest?nhg=0&mortgage=300000&houseValue=300000&mortgageType=6&frt=15': ,
  // 'overview/interest?nhg=0&mortgage=300000&houseValue=300000&mortgageType=6&frt=30': ,
  // 'calculate/interest-savings': ,
};
